import React from 'react'
import {  hkt_env_host } from '@/constants/constants_env'
import { encry } from './urlEncryption'
import { component_tool, framework_tool,utils_tool } from '@/tool';
import {connect} from "dva";

let {WizContainer,modelUtils} = framework_tool;
let {Session} = utils_tool
import { Spin } from 'antd'


export class HktClassroom extends  WizContainer {

  constructor(props){
    super(props);
    let record = Session.get('hktClassroom');
    this.state = {
      hktDefaultAvatar : record.avatar && record.avatar!="" ? record.avatar : null
    }
   this.record = record
  }
  

  componentDidMount() {
    if( (!this.record.avatar) || this.record.avatar=="" ){
      this.doAction({
        path: "commonConfig/queryByKey",
        payload: {
          key: "queryByKey",
          apiParams: {key: 'hktDefaultAvatar'},
        }
      });
    }
  }

  propsAndStateOnChange = {
    queryByKey: this._queryByKeyHandler.bind(this),
  }

  _queryByKeyHandler(nextProps, nextState) {
    let {queryByKey} = nextProps
    if (queryByKey['success'] && queryByKey['data']) {
      nextState.hktDefaultAvatar = queryByKey['data']
    }
  }

  render() {
    let { configLoading } = this.props
    let {hktDefaultAvatar } = this.state
    let record = Session.get('hktClassroom');
    let {userEmail, hostName, userPassword,ownerId} = record
    let en = encry(userEmail, hostName, userPassword, 1,"","",getOssFilePath(hktDefaultAvatar))
    let url = `${hkt_env_host}/${ownerId}?${en}`
    return ( 
        <div style={{ height:"100%",width:"100%",minHeight: "500px"}}>
          <Spin tip='加载中...' spinning={!!configLoading}>
            <iframe
              style={{ width: '100%', height:   window.document.body.scrollHeight + 'px', overflow: 'visible' }}
              // onLoad={() => {
              //   this.setState({
              //     'iFrameHeight': window.document.body.scrollHeight + 'px'
              //   });
              // }}
              ref='iframe'
              src={url}
              width='100%'
              height={  window.document.body.scrollHeight + 'px'}
              scrolling='no'
              frameborder='0'
              allow="camera; microphone; fullscreen; display-capture; autoplay"
            />
            </Spin>
        </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { commonConfig } = state;
  const queryByKey = modelUtils.getModelEntity(commonConfig, 'queryByKey');
  const load = modelUtils.getLoadingState(state, 'commonConfig');
  return {
    queryByKey,
    ...load
  }
};

export default connect(mapStateToProps)(HktClassroom);

